export default "__VITE_ASSET__CUpE75bh__"